import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { useEffect, useState } from "react";
import { Global } from "@emotion/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AuthProvider } from "./context/AuthContext";
import { ClientDataProvider } from "./context/ClientDataProvider";
import { DashboardPageProvider } from "./context/DashboardPageContext";

import { globalStyles } from "./styles";
import Navbar from "./components/HomePage/Navbar/Navbar";
import { Footer } from "./components/HomePage/Footer";
import AirbnbPartnership from "./pages/AirbnbPartnership/AirbnbPartnership";
import VendingAtmPartnership from "./pages/VendingAtmPartnership/VendingAtmPartnership";
import { AirbnbContactUsPage } from "./pages/AirbnbContactUs/AirbnbContactUs";
import AirbnbAboutUsPage from "./pages/AirbnbAboutUs/AirbnbAboutUs";
import VendingAtmAboutUsPage from "./pages/VendingAtmAboutUs/VendingAtmAboutUs";
import { VendingATMContactUsPage } from "./pages/VendingAtmContactUs/VendingAtmContactUs";
import { Login } from "./pages/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import { ProtectedRoute } from "./utils/ProtectedRoute/ProtextedRoute";

const queryClient = new QueryClient();

const AppContent = () => {
  const location = useLocation();
  const [isDash, setDash] = useState<boolean>(location.pathname.includes("dashboard"));

  useEffect(() => {
    setDash(location.pathname.includes("dashboard"));
  }, [location.pathname]);

  return (
    <>
      {!isDash && <Navbar />}
      <Routes>
        <Route path="/" element={<AirbnbPartnership />} />
        <Route path="/rental" element={<AirbnbPartnership />} />
        <Route path="/about" element={<AirbnbAboutUsPage />} />
        <Route path="/vending" element={<VendingAtmPartnership />} />
        <Route path="/contact" element={<AirbnbContactUsPage />} />
        <Route path="/vending/about" element={<VendingAtmAboutUsPage />} />
        <Route path="/vending/contact" element={<VendingATMContactUsPage />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <QueryClientProvider client={queryClient}>
              <ClientDataProvider>
                <DashboardPageProvider>
                  <ProtectedRoute children={<Dashboard />} />
                </DashboardPageProvider>
              </ClientDataProvider>
            </QueryClientProvider>
          }
        />
      </Routes>
      {!isDash && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Global styles={globalStyles} />
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
